import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./bombas.component.html')
})
export class BombasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/bombas/bombas.component.ts
 **/